
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col">
        <h4 class="modal-title">CA Acknowledgement</h4>
      </div>
    </div>
    <div class="modal-body">
      <div class="col">
        <div>You are acknowledging the source documentation have been validated and accurate before the contract account is created.</div><br>
        <p> <b>Key Attributes</b></p>
        <div class="row">
          <div class="col-md-6">
            <p>Sold to Party/ Customer BPID/CRS ID</p>
            <p>Company Code</p>
            <p>Sales Org</p>
            <p>Payment Terms</p>
          </div>
          <div class="col-md-6">
            <p>Tax Exception</p>
            <p>Customer Credit Approval / Credit Terms</p>
            <p>Invoice Distribution</p>
            <p>Currency - Contract Account</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" title="Cancel" (click)="cancel()">No</button>
      <button class="btn btn-primary" type="button" title="Save changes" (click)="acknowledge()">Yes</button>
    </div>
  </div>
</div>